var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8338)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8338",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0566C38.2678 49.0566 49.0234 38.301 49.0234 25.0332C49.0234 11.7654 38.2678 1.00977 25 1.00977C11.7322 1.00977 0.976562 11.7654 0.976562 25.0332C0.976562 38.301 11.7322 49.0566 25 49.0566Z",
    fill: "#6AAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0274 10.8884H14.0266C12.6965 11.5818 11.681 12.7565 11.1874 14.173C10.6938 15.5894 10.7592 17.1408 11.3703 18.5106C13.1784 22.5771 15.6153 26.3337 18.5914 29.6425L20.8229 31.874L35.6511 46.7023C39.3507 44.9027 42.5248 42.1811 44.8678 38.7993L39.3964 33.3279C39.1804 33.0093 38.9058 32.7347 38.5872 32.5187L17.9474 11.8791C17.5291 11.262 16.8987 10.8202 16.1759 10.6376C15.4532 10.4549 14.6886 10.5442 14.0274 10.8884Z",
    fill: "#4D8538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2348 29.6021C33.8573 29.346 33.4114 29.2096 32.9552 29.2108C32.499 29.212 32.0538 29.3507 31.6777 29.6088L30.5695 30.3695C29.9673 30.7823 29.2499 30.9938 28.5201 30.9737C27.7903 30.9536 27.0856 30.7029 26.507 30.2576C25.3902 29.3973 24.3223 28.4754 23.3082 27.4961C22.3289 26.482 21.4071 25.414 20.5469 24.2971C20.1015 23.7186 19.8508 23.0139 19.8307 22.284C19.8106 21.5542 20.0221 20.8368 20.4349 20.2346L21.1955 19.1264C21.4536 18.7503 21.5923 18.3051 21.5935 17.8489C21.5947 17.3928 21.4584 16.9468 21.2022 16.5694L18.0301 11.8946C17.6069 11.2704 16.9691 10.8234 16.238 10.6387C15.5069 10.4539 14.7333 10.5442 14.0644 10.8924H14.0636C12.7179 11.5939 11.6905 12.7823 11.1912 14.2154C10.6918 15.6484 10.7581 17.2179 11.3764 18.6038C13.2054 22.7175 15.6705 26.5179 18.6811 29.8652L20.9386 32.1226C24.2859 35.1332 28.0862 37.5982 32.2 39.4273C33.5858 40.0458 35.1554 40.1122 36.5884 39.613C38.0215 39.1137 39.2101 38.0864 39.9116 36.7408V36.7399C40.2598 36.071 40.3501 35.2974 40.1653 34.5663C39.9806 33.8352 39.5336 33.1974 38.9095 32.7743L34.2348 29.6021Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8338"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNumber);
export default __webpack_public_path__ + "static/media/contact_number.3b7f8fa02994915f460a8ae4d5f16b6e.svg";
export { ForwardRef as ReactComponent };